export default __webpack_public_path__ + "static/media/gearwise.91f9d179.PNG";